document.addEventListener("DOMContentLoaded", function () {
    const languageSwitcher = document.querySelector('.wpml-ls-current-language');
    if (languageSwitcher) {
        languageSwitcher.addEventListener('click', function (e) {
            e.preventDefault(); // Förhindra standardlänk-klick
            const subMenu = this.querySelector('.sub-menu');
            if (subMenu) {
                const isVisible = subMenu.style.display === 'block';
                subMenu.style.display = isVisible ? 'none' : 'block';
            }
        });
    }
});
